import React, {useState} from 'react'; 
import { Button, Modal } from 'react-bootstrap';
import Request from './Request';

const ModalRequest = () => {
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  return (
    <div>
      <Button variant="success" style={{width:"90%"}} onClick={handleShow}>
        Contáctanos
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <div  style={{ textAlign: 'center' }}>
          <Modal.Title>
            <h1>ENVIANOS TU CONSULTA</h1>
          </Modal.Title>
          <Modal.Title>
            <h5 style={{ marginTop: '10px' }}>TE RESPONDEMOS A LA BREVEDAD</h5>
          </Modal.Title>
          </div>
        </Modal.Header>

        <Modal.Body>
          <Request/>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ModalRequest;
